import { Loading } from "@/components";
import { MEDIA } from "@/styles/common";
import { Flex } from "@chakra-ui/react";
import { RoomCard } from "@components/card";
import { useCheckInValue, useCheckOutValue, useSetSelectedPerson, useSetSelectedRoomState } from "@shared/client";
import { ReserveInfoResponse, useGetReserve } from "@shared/server";
import { HandleRoomSelectionProps } from "./types";

export const ReserveRoomList = () => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const { data } = useGetReserve<ReserveInfoResponse>({ checkIn, checkOut });
    const { isMobile, isTablet } = MEDIA();

    const setSelectedRooms = useSetSelectedRoomState();
    const setSelectedPerson = useSetSelectedPerson();

    const sortedRooms = data?.currentRooms.sort((a, b) => {
        if (a.isAvailableBook === b.isAvailableBook) {
            return 1;
        }
        return a.isAvailableBook ? -1 : 1;
    });

    const handleRoomSelection = ({ roomIdx, isSelected, newOffPrice, person }: HandleRoomSelectionProps) => {
        setSelectedPerson({ adult: 0, child: 0, infant: 0 });
        setSelectedRooms((prev) => {
            if (isSelected) {
                const updatedRooms = prev.filter((room) => room.roomIdx !== roomIdx);
                return [...updatedRooms, { roomIdx, newOffPrice, person }];
            }

            if (!isSelected) {
                return prev.filter((room) => room.roomIdx !== roomIdx);
            }

            return [];
        });
    };

    let deviceSize = "0";
    if (isTablet) deviceSize = "2";
    if (isMobile) deviceSize = "1";

    return sortedRooms && data ? (
        <Flex
            w="100%"
            display={isTablet ? "grid" : "flex"}
            gridTemplateColumns={`repeat(${deviceSize}, 1fr)`}
            flexDir="column"
            columnGap="24px"
            rowGap={isTablet ? "48px" : "24px"}
        >
            {sortedRooms.map((room, idx) => (
                <RoomCard
                    dayNight={data.dayNights}
                    currentRoom={room}
                    key={idx + 1}
                    onRoomSelection={handleRoomSelection}
                />
            ))}
        </Flex>
    ) : (
        <Loading h="320px" spinnerSize="xl">
            객실 정보를 불러오고 있습니다...
        </Loading>
    );
};
